<template>
  <div>
    <v-simple-table class="borderless-table">
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              Name
            </th>
            <th>
              Expiry Date
            </th>
            <th>
              Actions
            </th>
            <th>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in documentsList"
            :key="item.type"
            class="bg-white"
          >
            <td>{{ item.type }}</td>
            <td>{{ item.expiryDate }}</td>
            <td>
              <v-btn small text link color="blue" @click="prepareUploadDialog(item)">Upload</v-btn>
<!--              <label class="blue&#45;&#45;text">
                <input type="file"  style="display: none;" @change="onFileChange($event,item.type)">
                Upload
              </label>-->
            </td>
            <td>{{item.file ? item.file.name.substring(item.file.name.length - 25) : ''}}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-layout>
      <v-container>
        <v-flex>
          <v-dialog
            v-model="uploadDialog"
            width="500"
          >
            <v-card>
              <v-card-title class="headline grey lighten-2">
                Uploaded Document <small class="ml-1">{{selectedDocument.name}}</small>
                <v-spacer></v-spacer>
                <v-icon @click="uploadDialog = false">mdi-close</v-icon>
              </v-card-title>
              <v-card-text>
                <v-row dense>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <label class="cmr-label-text">Expiry Date</label>
                    <DateInputIconV2
                      v-model="selectedDocument.expiryDate"
                      :clearable="true"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <FileInput
                      label="Upload Document"
                      icon="insert_drive_file"
                      accept="*"
                      @fileInput="handleDocumentInput"
                    />
                  </v-col>
                </v-row>

              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  text
                  @click="submitForUpload"
                >
                  Submit
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import FileInput from "@/components/widget/input/FileInputV2.vue";
import DateInputIconV2 from '@/components/widget/input/DateInputIconV2'


export default {
  name: "DriverNewDocumentsBox",
  components: {FileInput, DateInputIconV2},
  props: {
    driverId: {
      default: null,
      type: String
    },
    isUpdate: {
      default: false,
      type: Boolean
    },
    requiredDocuments: {
      default: null,
      type: Array
    }
  },
  data () {
    return {
      dateForNewDocument: new Date().toISOString().substr(0, 10),
      uploadedFile: null,
      selectedItem: null,
      uploadDialog: false,
      selectedDocument: "",
    }
  },
  computed:{
    driverUploadedDocuments () {
      return this.$store.getters['document/getDriverDocuments']
    },
    subtractAlreadyUploaded () {
      if (!this.driverUploadedDocuments.length) {
        return this.requiredDocuments
      }
      let documents = []
      this.requiredDocuments.forEach(doc => {
        let existing = this.driverUploadedDocuments.find(document => {
          return document.type == doc.type
        })
        if (!existing) {
          documents.push(doc)
        }
      })
      return documents
    },
    documentsList () {
      if (this.isUpdate) {
        return this.subtractAlreadyUploaded
      }
      return this.requiredDocuments
    }
  },
  created() {
  },
  methods: {
    submitForUpload () {
      this.uploadDialog = false
      this.$emit('documentUploaded', {type: this.selectedDocument.type, file: this.uploadedFile, expiryDate: this.selectedDocument.expiryDate })
    },
    handleDocumentInput(file) {
      this.uploadedFile = file;
    },
    prepareUploadDialog (document) {
      this.selectedDocument = document
      this.uploadDialog = true
    },
  }
}
</script>

<style >

.borderless-table table tr td,th {
  border: none !important;
}


</style>